class ElasticSearchHelper {
    static buildFilterListRequestBody(obj, culture) {
        let body = {};
        body._source = [
            "Id",
            "OriginalItemId"
        ];
        body.from = 0;
        body.size = 10000;

        var query = this.buildContentHubQuery(obj);
        this.addFilterQueryToElasticSearchBody(body, query, culture);

        if (window.contentHubSkipIDs && window.contentHubSkipIDs.length > 0) {
            let filter = {
                ids: {
                    values: window.contentHubSkipIDs
                }
            }

            body.query.bool['filter'] = filter;
        }

        let prefilterQuery = this.getPrefilterQuery();
        if (prefilterQuery) {
            this.addPrefilterQuery(body, prefilterQuery);
        }

        return body;
    }

    static buildNewsRequestBody(obj, page, size, numberOfItems, culture, filterYearOnly) {
        let result = {
            body: {},
            onlyFilteredByYear: false
        };
        let body = {};
        body.from = (page - 1) * numberOfItems;
        body.size = size;
        if (!filterYearOnly) {
            body.sort = { "NewsReleaseDate.keyword": { "order": "desc" } };
        }


        var newsQueryResult = this.buildNewsQuery(obj, 'NewsReleaseDate.keyword', filterYearOnly);
        var query = newsQueryResult.query;
        this.addFilterQueryToElasticSearchBody(body, query, culture);

        if (window.contentHubSkipIDs) {
            let idsObj = {
                ids: {
                    values: window.contentHubSkipIDs
                }
            };

            body.query.bool['must_not'] = idsObj;
        }

        let prefilterQuery = this.getPrefilterQuery();
        if (prefilterQuery) {
            this.addPrefilterQuery(body, prefilterQuery, !newsQueryResult.hasYearSelected);
        }

        result.body = body;
        result.onlyFilteredByYear = newsQueryResult.onlyFilteredByYear;
        return result;
    }

    static buildContentHubRequestBody(obj, page, size, numberOfItems, culture) {
        let body = {};
        body.from = (page - 1) * numberOfItems;
        body.size = size;
        body.sort = { DatePublished: { "order": "desc" } };


        var query = this.buildContentHubQuery(obj);
        this.addFilterQueryToElasticSearchBody(body, query, culture);

        if (window.contentHubSkipIDs) {
            let idsObj = {
                ids: {
                    values: window.contentHubSkipIDs
                }
            };

            body.query.bool['must_not'] = idsObj;
        }

        let prefilterQuery = this.getPrefilterQuery();
        if (prefilterQuery) {
            this.addPrefilterQuery(body, prefilterQuery);
        }

        return body;
    }

    static buildVoyageTopicsBody(obj, page, size, numberOfItems, culture) {
        let body = {};
        body.from = (page - 1) * numberOfItems;
        body.size = size;
        body.sort = { DatePublished: { "order": "desc" } };

        let query = {
            bool: {
                must: []
            }
        };


        let voyageTopics = [
            { "term": { "topics": "voyage" } },
            { "term": { "topics": "autonomous-shipping" } },
            { "term": { "topics": "ship-traffic-control" } },
            { "term": { "topics": "smart-simulation" } },
            { "term": { "topics": "smart-voyage-optimisation" } }
        ]

        this.addShouldExpression(query, voyageTopics);
        this.addFilterQueryToElasticSearchBody(body, query, culture);

        if (window.contentHubSkipIDs) {
            let idsObj = {
                ids: {
                    values: window.contentHubSkipIDs
                }
            };

            body.query.bool['must_not'] = idsObj;
        }

        return body;
    }

    static addFilterQueryToElasticSearchBody(body, query, culture) {
        let mustMatchLanguage = null;

        if (culture && culture.length > 0) {
            mustMatchLanguage = { "match": { "Language": culture } }
        }

        var defaultMust = mustMatchLanguage ? [mustMatchLanguage] : [];

        if (!query) {
            body.query = {
                bool: {
                    must: defaultMust
                }
            };
        } else {
            if (!query.bool.must) {
                query.bool.must = defaultMust;
            } else if (Array.isArray(query.bool.must)) {
                if (mustMatchLanguage) {
                    query.bool.must.push(mustMatchLanguage);
                }
            } else {
                var must = defaultMust;
                must.push(query.bool.must);
                query.bool.must = must;
            }
            body.query = query;
        }
    }

    static buildNewsQuery(obj, dateFieldName, filterYearOnly) {
        if (!filterYearOnly) {
            filterYearOnly = false;
        }
        var result = {
            hasYearSelected: false,
            onlyFilteredByYear: true
        };

        if (!(obj && obj.length > 0)) {
            return result;
        }

        let query = {
            bool: {
                must: []
            }
        }

        var keyworSearchConditions = [];
        var dateConditions = [];
        if (!dateFieldName) {
            dateFieldName = 'DatePublished';
        }

        obj.forEach((e, idx, array) => {
            if (e.taxonName && e.taxonName.toLowerCase() === "year") {
                if (e.value && !isNaN(e.value)) {
                    var year = Number(e.value);

                    dateConditions.push({
                        range: {
                            [dateFieldName]: {
                                gte: (year - 1) + '-12-31',
                                lte: year + 1 + '',
                            }
                        }
                    });
                    result.hasYearSelected = true;
                }
            }
            else if (e.hasOwnProperty('fieldName') && !filterYearOnly) {
                var searchConditions = this.getKeywordSearchConditions(e.fieldName, e.value);

                for (var j = 0; j < searchConditions.length; j++) {
                    keyworSearchConditions.push(searchConditions[j]);
                }
                result.onlyFilteredByYear = false;
            }
            else if (!filterYearOnly) {
                let singleCategoryConditions = [];
                let propName = (e.taxonName == "Categories" || e.taxonName == "Industries" || e.taxonName == "Business function" ? e.taxonName.replace(/\s/g, '') : e.taxonName.toLowerCase().replace(/\s/g, '')) + ".keyword";

                for (let i = 0; i < e.value.length; i++) {
                    let propValue = e.value[i];

                    let categoryCondition = {
                        match: {
                            [propName]: propValue
                        }
                    };

                    singleCategoryConditions.push(categoryCondition);
                    result.onlyFilteredByYear = false;
                }
                this.addShouldExpression(query, singleCategoryConditions);
            }
        });

        this.addShouldExpression(query, keyworSearchConditions);
        this.addShouldExpression(query, dateConditions);

        result.query = query;
        return result;
    }

    static buildContentHubQuery(obj) {
        if (!(obj && obj.length > 0)) {
            return;
        }

        let query = {
            bool: {
                must: []
            }
        }

        var keyworSearchConditions = [];
        // var taxaConditions = [];
        var dateConditions = [];

        obj.forEach((e, idx, array) => {
            if (e.hasOwnProperty('fieldName')) {
                var searchConditions = this.getKeywordSearchConditions(this.uppercaseFirstLetter(e.fieldName), e.value);

                for (var j = 0; j < searchConditions.length; j++) {
                    keyworSearchConditions.push(searchConditions[j]);
                }
            }
            else if (e.taxonName && e.taxonName.toLowerCase() === "year") {
                if (e.value && !isNaN(e.value)) {
                    var year = Number(e.value) + 1;
                    var yearLte = year + '-01-01';

                    dateConditions.push({
                        range: {
                            "DatePublished": {
                                lte: yearLte
                            }
                        }
                    });
                }
            }
            else {
                let singleCategoryConditions = [];
                let propName = (e.taxonName == "Categories" || e.taxonName == "Industries" || e.taxonName == "Business function" ? e.taxonName.replace(/\s/g, '') : e.taxonName.toLowerCase().replace(/\s/g, '')) + ".keyword";

                for (let i = 0; i < e.value.length; i++) {
                    let propValue = e.value[i];

                    let categoryCondition = {
                        match: {
                            [propName]: propValue
                        }
                    };

                    singleCategoryConditions.push(categoryCondition);
                    // taxaConditions.push(categoryCondition);
                }

                this.addShouldExpression(query, singleCategoryConditions);
            }
        });

        this.addShouldExpression(query, keyworSearchConditions);
        // this.addShouldExpression(query, taxaConditions);
        this.addShouldExpression(query, dateConditions);

        return query;
    }

    static addShouldExpression(query, conditions) {
        if (conditions.length > 0) {
            if (conditions.length == 1) {
                query.bool.must.push(conditions[0]);
            } else {
                var shouldExpression = {
                    "bool": {
                        "should": [],
                        "minimum_should_match": 1
                    }
                };

                for (let i = 0; i < conditions.length; i++) {
                    shouldExpression.bool.should.push(conditions[i]);
                }

                query.bool.must.push(shouldExpression);
            }
        }
    }

    static getKeywordSearchConditions(fieldName, searchPhrase) {
        var keyworSearchConditions = [];

        var value = searchPhrase.replace(/#|_|\?|,|\.|!|:|\"/g, '').replace(/\s+/, " ");
        var words = value.split(" ");

        if (words && words.length > 0) {
            if (words.length === 1) {
                var condition = this.buildFuzzyWordMatch(fieldName, words[0]);
                keyworSearchConditions.push(condition);
            } else {
                var exact = this.buildExactPhraseMatch(fieldName, searchPhrase);
                keyworSearchConditions.push(exact);

                if (searchPhrase !== value) {
                    var exactSanitized = this.buildExactPhraseMatch(fieldName, value);
                    keyworSearchConditions.push(exactSanitized);
                }

                var fuzzyTerms = [];
                for (var j = 0; j < words.length; j++) {
                    if (words[j].length > 2) {
                        fuzzyTerms.push(words[j]);
                    }
                }

                var fuzzy = this.buildFuzzyPhraseMatch(fieldName, fuzzyTerms, "1");
                keyworSearchConditions.push(fuzzy);
            }
        }

        return keyworSearchConditions;
    }

    static buildFuzzyWordMatch(fieldName, value) {
        var match = {
            match: {
                [fieldName]: {
                    query: value,
                    fuzziness: "AUTO"
                }
            }
        }

        return match;
    }

    static buildExactPhraseMatch(fieldName, value) {
        var match = {
            match_phrase: {
                [fieldName]: {
                    query: value
                }
            }
        }

        return match;
    }

    static buildFuzzyPhraseMatch(fieldName, parts, fuzziness) {
        if (!fuzziness) {
            fuzziness = "AUTO";
        }

        var span = {
            span_near: {
                clauses: [],
                slop: 2,
                in_order: "true"
            }
        }

        for (var i = 0; i < parts.length; i++) {
            var clause = {
                span_multi: {
                    match: {
                        fuzzy: {
                            [fieldName]: {
                                fuzziness: fuzziness,
                                value: parts[i]
                            }
                        }
                    }
                }
            };

            span.span_near.clauses.push(clause);
        }

        if (span.span_near.clauses.length > 0) {
            return span;
        } else {
            return '';
        }
    }

    static getPrefilterQuery() {

        let prefilterDataParsed = "";
        var prefilterData = document.getElementsByClassName('prefilter-data')[0];

        if (prefilterData) {
            let prefilterDataAttr = prefilterData.getAttribute('data-prefilter-data');

            if (prefilterDataAttr && prefilterDataAttr.length > 0) {
                prefilterDataParsed = JSON.parse(prefilterDataAttr);
            }
            if (prefilterDataParsed.length > 0) {
                prefilterDataParsed.forEach((e) => {
                    if (Array.isArray(e.value) && e.value.length == 1) {
                        e.value = e.value[0];
                    }
                });
            }
        }

        return prefilterDataParsed;
    }

    static addPrefilterQuery(body, prefilterDataParsed, checkForDate) {
        if (!(prefilterDataParsed && prefilterDataParsed.length > 0)) {
            return;
        }

        let prefilteredShouldQuery = {
            bool: {
                should: [],
                "minimum_should_match": 1
            }
        };

        var dateConditions = [];

        prefilterDataParsed.forEach((e, idx, array) => {
            if (e.shouldExclude) {
                let propName = e.name + ".keyword";
                body.query.bool.must_not = body.query.bool.must_not || [];
                body.query.bool.must_not.push({
                    term: {
                        [propName]: e.value
                    }
                });
            }
            else {
                e.name = e.name === 'topics' ? e.name : this.uppercaseFirstLetter(e.name);
                if (checkForDate && e.isDate) {
                    var year = Number(e.value);
                    dateConditions.push({
                        range: {
                            [e.name]: {
                                gte: (year - 1) + '-12-31',
                                lte: year + 1 + '',
                            }
                        }
                    });
                }
                else if (e.isDate == false) {
                    let filterIsAdded = false;
                    let propName;
                    if (e.isTaxonomy) {
                        propName = e.name + ".keyword";
                        if (Array.isArray(e.value)) {
                            e.value.forEach((val) => {
                                let current = { match: { [propName]: val } };
                                prefilteredShouldQuery.bool.should.push(current);
                            });
                            filterIsAdded = true;
                        }
                    } else {
                        propName = e.name;
                    }

                    if (!filterIsAdded) {
                        let current = { match: { [propName]: e.value } };
                        prefilteredShouldQuery.bool.should.push(current);
                    }
                }
            }
        });

        if (dateConditions.length > 0) {
            this.addShouldExpression(body.query, dateConditions);
        }
        if (prefilteredShouldQuery.bool.should.length > 0) {
            body.query.bool.must.push(prefilteredShouldQuery);
        }
    }

    static uppercaseFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}

export default ElasticSearchHelper;

